import React, { Component } from "react";
import { Navigate  } from 'react-router-dom';
import axios from 'axios'; 

import Serverurl from './Apiurl';
import Button from '@mui/material/Button';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
//import { DropzoneArea } from 'material-ui-dropzone';
//import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';

export default class Customerimport extends Component {
	
	constructor(props) 
	  {super();
		 this.state = {redirect:false,pagename:'',errormessage:'',open:false,imgfile:'',primarybtntext:'Upload'}
	  }
			componentWillMount() { 
localStorage.setItem("pageactive",6)
}
 componentDidMount()
	{
		document.title = "Isifol - Customer Import";
		if(localStorage.getItem("ISIuserid")==null)
		  {

		   this.setState({
            logredirect: true,
			pagename:'/Login'
          })
		  }	
	}
	handleErrorclose=(event)=>{
	  
	this.setState({open: false});  
  }
  OnImportSubmit=(event)=>{
	   event.preventDefault(); 
	   var selectedFile = this.state.imgfile[0];
	   if (!selectedFile || selectedFile === "") {
    this.setState({
      errormessage: "Please upload a CSV file.",
      open: true
    });
    window.scrollTo({ top: 0 });
    return false;
  }

var validTypes = ["text/csv", "application/vnd.ms-excel"];
  if (validTypes.indexOf(selectedFile.type) === -1) {
    this.setState({
      errormessage: "Invalid file type. Only CSV files are allowed.",
      open: true
    });
    window.scrollTo({ top: 0 });
    return false;
  }
	  if( this.state.imgfile[0]==="")
	  {
   this.setState({ errormessage:"Upload file.", open: true });
    window.scrollTo({ top: 0 });
    return false;
	  }		  
	   var formData = new FormData();
	 formData.append('action','customerimport')
		   formData.append('Filedata',selectedFile)		   
	formData.append('userid',localStorage.getItem("ISIuserid"))
	this.setState({primarybtntext:'Processing...'});
	axios.post(localStorage.getItem("ISIurl")+"ajaxcustomer.php", formData, {
	}).then(res => {
		
		this.setState({primarybtntext:'Upload',open:true,errormessage:'Uploaded successfully'});
		
	});
  }
 handleFilesChange = (files) => {
    this.setState({ imgfile: files });
  };
	render() {
if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }
	 return (
  
	 <React.Fragment> 
	  <div className="pagebox-col">
	 <div className="">
			<div className="boxheading">
				  <div className="contntpad">
					 <p>  <Collapse in={this.state.open}>
										<Alert
										  action={
											<IconButton
											  aria-label="close"
											  color="inherit"
											  size="small"
											  onClick={() => {
											   this.handleErrorclose();
											  }}
											>
											  <CloseIcon fontSize="inherit" />
											</IconButton>
										  } severity="error"
										>
										{this.state.errormessage}
										</Alert>
								</Collapse></p>
				  <h2> Import Customer</h2>
				  </div> </div>
	   <div className="contntpad ">
	    <div className="formviewatt ">
	   
	

	 <p className="fileuploaddrop">
	 {/* <input
                    multiFile={false}
                    onFilesChange={this.handleFilesChange}
                    onContextReady={(context) => {}}
	 />*/}
	 {/* <DropzoneArea dropzoneText="" 
 showPreviews={true}
  showPreviewsInDropzone={false}
  useChipsForPreview
  previewGridProps={{container: { spacing: 1, direction: 'row' }}}
dropzoneText={"Drag and drop/Select CSV file here"}
  previewText="Uploaded files"
maxFileSize={5000000} Icon={CloudUploadIcon} dropzoneClass="filesupld" filesLimit={1} acceptedFiles={['text/csv']} 
 
 
  onChange={(files) => {
  var file, img;
  var _URL = window.URL || window.webkitURL;
  this.setState({ imgfile: files })
  
		
 

	 }}
  
 
/>*/} 
</p> <p className="alignright"><Button variant="standard" className="frmSecondarybtn" endIcon={<CheckRoundedIcon />} onClick={this.OnImportSubmit}>
								  {this.state.primarybtntext}
						</Button></p>
	   <div className="clear"></div>
	   </div>  </div>
	   </div>
	   </div>
	 </React.Fragment> 
	 )
	}
}








